export const socialIconSize = '2.3rem';

export const contentMaxWidth = '1240px';
